import { Storage } from "aws-amplify";
import EventsService from "../services/eventsService";

// Fotos de un evento en S3 (bucket de originales, nivel public). La clave es
// `${eventId}/FtpUsers/${userId}/${archivo}`: el segundo segmento dice quién la subió.
// Lo usan Subir fotos, la galería del invitado y el Resumen del invitado.

const PAGE_SIZE = 1000;
const DELETE_CONCURRENCY = 250;

export const uploaderIdFromKey = (key) => key?.split("/")[2];

/**
 * Lista todas las claves del evento y separa las del usuario.
 * @returns {Promise<{ mine: string[], all: string[] }>}
 */
export async function listEventPhotoKeys(eventId, userId) {
    const mine = [];
    const all = [];
    let nextToken = undefined;
    do {
        const response = await Storage.list(`${eventId}/FtpUsers/`, {
            pageSize: PAGE_SIZE,
            nextToken,
        });
        for (const photo of response.results) {
            all.push(photo.key);
            if (uploaderIdFromKey(photo.key) === userId) mine.push(photo.key);
        }
        nextToken = response.nextToken;
    } while (nextToken);
    return { mine, all };
}

/**
 * Envía al backend las claves por lotes; `onProgress(n)` recibe el acumulado borrado.
 * El backend autoriza cada foto y coordina la retirada de sus copias públicas.
 */
export async function removePhotoKeys(keys, { concurrency = DELETE_CONCURRENCY, onProgress } = {}) {
    const queue = [...keys];
    let processed = 0;
    while (queue.length > 0) {
        const batch = queue.splice(0, Math.max(1, Math.min(250, concurrency)));
        await EventsService.deletePhotos(batch);
        processed += batch.length;
        if (onProgress) onProgress(processed);
    }
    return processed;
}
